import iAmUserComponent from '@/components/pages/InformationPortal/IAM/User/IamUser.vue'
import iAmUserGroup from '@/components/pages/InformationPortal/IAM/UserGroup/UserGroup.vue'
import iAmUserRole from '@/components/pages/InformationPortal/IAM/Roles/Roles.vue'
import pageRoute from '../libs/constant/pageRoutes'
const routes = [
    {
      path: pageRoute.signIn,
      name: 'signin-page',
      meta: {
        title: 'Accura'
      },
      component: require('@/components/pages/SignInPage/SignInPage.vue').default
    },{
      path: pageRoute.forgotPassword,
      name: 'forgot-password-page',
      component: require('@/components/pages/ForgotPassword/ForgotPassword.vue').default
  },
    {
      path: pageRoute.resetPassword,
      name: 'reset-password-page',
      component: require('@/components/pages/ResetPassword/ResetPassword.vue').default
    },
    {
      path: pageRoute.resendVerificationEmail,
      name: 'reset-verification-email',
      component: require('@/components/pages/ResendVerificationPage/ResendVerificationPage.vue').default
    },
    {
      path: pageRoute.verifyEmail,
      name: 'signin-page',
      component: require('@/components/pages/SignInPage/SignInPage.vue').default
    },
    {
      path: pageRoute.signUp,
      name: 'signup-page',
      component: require('@/components/pages/SignUpPage/SignUpPage.vue').default
    },
    {
      path: pageRoute.term,
      name: 'term-condition',
      component: () => import(/* webpackChunkName: "privacy" */'@/components/component/TermAndPrivacy/Term.vue')
    },
    {
      path: pageRoute.privacy,
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "privacy" */'@/components/component/TermAndPrivacy/Privacy.vue')
    },
    {
      path: pageRoute.prohibitedBusiness,
      name: 'prohibited-business',
      component: () => import(/* webpackChunkName: "privacy" */'@/components/component/TermAndPrivacy/ProhibitedBusiness.vue')
    },
    {
      path: '/twitterAuth',
      name: pageRoute.twitterConfirmation,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: `/${pageRoute.facebookConfirmation}`,
      name: pageRoute.facebookConfirmation,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: `/${pageRoute.organisationInvite}`,
      name: pageRoute.organisationInvite,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: `/${pageRoute.billingManagerInvite}`,
      name: pageRoute.billingManagerInvite,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: `/${pageRoute.collaboratorInvite}`,
      name: pageRoute.collaboratorInvite,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: `/${pageRoute.teamInvite}`,
      name: pageRoute.teamInvite,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: '/pocket-message',
      name: pageRoute.pocketConfirmation,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue')
    },
    {
      path: '/source-message',
      name: pageRoute.sourceConfirmation,
      component: () => import('@/components/social/shareSourceConfirmation/shareSourceConfirmation.vue')
    },
    {
      path: `/${pageRoute.claimRequestConfirmation}`,
      name: pageRoute.claimRequestConfirmation,
      component: () => import('@/components/social/shareSourceConfirmation/shareSourceConfirmation.vue') 
    },
    {
      path: `/${pageRoute.deleteUserAccount}`,
      name: pageRoute.deleteUserAccount,
      component: () => import('@/components/social/AccountConfirmation/AccountConfirmation.vue') 
    },
    {
      path: '/emb/list',
      name: 'embeddable-list',
      component: () => import('@/components/embeddable/Collection/Collection.vue') 
    },
    {
      path: '/emb/article',
      name: 'embeddable-article',
      component: () => import('@/components/embeddable/Articles/Articles.vue') 
    },
    {
      path: `/${pageRoute.errorPage}`,
      name: pageRoute.errorPage,
      component: () => import('@/components/pages/ErrorPage/ErrorPage.vue') 
    },
    {
      path: '/s/:id',
      name: 'short-url',
      component: () => import('@/components/pages/ShortUrl/ShortUrl.vue')
    },
    {
      path: pageRoute.admin,
      name: 'admin-home',
      component: () => import(/* webpackChunkName: "group-admin" */'@/components/component/AdminHome/AdminHome.vue'),
      children: [
        {
          path: pageRoute.userOverview,
          name: pageRoute.userOverview,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/admin/Blank/Blank.vue').default,
        },
        {
          path: pageRoute.userSubscription,
          name: pageRoute.userSubscription,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/Reuse/DisplayTable/DisplayTable.vue').default,
        },
        {
          path: pageRoute.infoOverview,
          name: pageRoute.infoOverview,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/admin/Blank/Blank.vue').default,
        },
        {
          path: 'articles',
          name: pageRoute.infoArticles,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/Reuse/DisplayTable/DisplayTable.vue').default,
          props: {prop: 'articles'}
        },
        {
          name: 'editArticles',
          path: 'article/:id',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: () => import(/* webpackChunkName: "group-admin-edit-pages" */ '@/components/component/TestAdmin/ArticleForm/ArticleForm.vue')
        },
        {
          name: 'editAuthors',
          path: 'author/:id',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: () => import(/* webpackChunkName: "group-admin-edit-pages" */ '@/components/component/TestAdmin/AuthorForm/AuthorForm.vue')
        },
        {
          name: 'editPublishers',
          path: 'publisher/:id',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: () => import(/* webpackChunkName: "group-admin-edit-pages" */ '@/components/component/TestAdmin/PublisherForm/PublisherForm.vue')
        },
        {
          name: 'editPublications',
          path: 'publication/:id',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: () => import(/* webpackChunkName: "group-admin-edit-pages" */ '@/components/component/TestAdmin/PublicationForm/PublicationForm.vue')
        },
        {
          name: 'editUsers',
          path: 'user/:id',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: () => import(/* webpackChunkName: "group-admin-edit-pages" */ '@/components/component/TestAdmin/UserForm/UserForm.vue')
        },
        {
          path: 'authors',
          name: pageRoute.infoAuthors,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/Reuse/DisplayTable/DisplayTable.vue').default,
        },
        {
          path: 'publishers',
          name: pageRoute.infoPublishers,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/Reuse/DisplayTable/DisplayTable.vue').default,
        },
        {
          path: 'publications',
          name: pageRoute.infoPublications,
          meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Admin'
          },
          component: require('@/components/component/Reuse/DisplayTable/DisplayTable.vue').default,
        },
      ]
    },
    {
      path: '/aa/add-publisher-card',
      meta: {
        requiresAuth: true,
        isAdmin: true
      },
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      children: [
        {
          name: 'AddAdminPublisher',
          path: '/',
          meta: {
            requiresAuth: true,
            isAdmin: true
          },
          component: () => import('@/components/component/TestAdmin/AddNewPublisher/AddNewPublisher.vue'),
        }
      ]
    },
    {
      path: pageRoute.home,
      name: 'landing-page',
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      children: [
        {
          path: pageRoute.overview,
          name: pageRoute.overview,
          meta: {
            requiresAuth: true,
            title: 'Account | overview'
          },
          component: require('@/components/pages/Overview/Overview.vue').default
        },
        {
          path: pageRoute.communication,
          name: pageRoute.communication,
          meta: {
            requiresAuth: true,
            title: 'Account | communication'
          },
          component: () => import('@/components/pages/Communication/Communication.vue')
        },
        {
          path: pageRoute.subscription,
          name: pageRoute.subscription,
          meta: {
            requiresAuth: true,
            title: 'Account | subscription'
          },
          component: () => import('@/components/pages/Subscription/Subscription.vue')
        },
        {
          path: pageRoute.payment,
          name: pageRoute.payment,
          meta: {
            requiresAuth: true,
            title: 'Account | payment'
          },
          component: () => import('@/components/pages/Payment/Payment.vue')
        },
        {
          path: pageRoute.security,
          name: pageRoute.security,
          meta: {
            requiresAuth: true,
            title: 'Account | security'
          },
          component: () => import('@/components/pages/Security/Security.vue')
        },
        {
          path: pageRoute.account,
          name: pageRoute.account,
          meta: {
            requiresAuth: true,
            title: 'Account | account'
          },
          component: () => import('@/components/pages/Account/Account.vue')
        },
        {
          path: '',
          redirect: {
            name : pageRoute.overview
          }
        }
      ]
    },
    {
      path: '/dp',
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      children: [
        {
          path: `donations`,
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/Donation.vue'),
          children: [
            {
              path: `/`,
              name: 'donations',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/DonationList/DonationList.vue'),
            },
            {
              path: `:type/:id`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/DonationDetail/DonationDetail.vue'),
              children: [
                {
                  path: `/`,
                  name: 'donations-profile',
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/DonationProfile/DonationProfile.vue')
                },
                {
                  path: `payout`,
                  name: 'donations-payout',
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/DonationPayout/DonationPayout.vue'),
                },
                {
                  path: `donors`,
                  name: 'donations-donors',
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/DonorsList/DonorsList.vue'),
                },
                {
                  path: `donations`,
                  name: 'donations-donations',
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "donations" */'@/components/pages/InformationPortal/Donations/DonationsPage/DonationsPage.vue'),
                },
              ]
            },
          ]
        },
      ]
    },
    {
      path: '/iam-dashboard',
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      children:[
        {
          path: '/',
          component: require(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/IAM.vue').default,
          meta: {
            requiresAuth: true
          },
          children: [
            {
              name: pageRoute.IAMMainDashboard,
              component: require(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/Dashboard/IamDashboard.vue').default,
              path: '/',
              meta: {
                requiresAuth: true
              }
            },
            {
              name: pageRoute.iamUser,
              path: pageRoute.iamUser,
              meta: {
                requiresAuth: true
              },
              // component: () => require(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/User/IamUser.vue'),
              component: iAmUserComponent
            },
            {
              name: pageRoute.iamUserGroup,
              path: pageRoute.iamUserGroup,
              meta: {
                requiresAuth: true
              },
              // component: () => require(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/UserGroup/UserGroup.vue'),
              component: iAmUserGroup
            },
            {
              name: pageRoute.iamCreateGroup,
              path: pageRoute.iamCreateGroup,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/CreateGroup/CreateGroup.vue'),
            },
            {
              name: pageRoute.iamCreateGroup,
              path: 'iam-create-group/edit/:id',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/CreateGroup/CreateGroup.vue'),
            },
            {
              name: pageRoute.iamRoles,
              path: pageRoute.iamRoles,
              meta: {
                requiresAuth: true
              },
              // component: () => require(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/Roles/Roles.vue').default,
              component: iAmUserRole
            },
            {
              name: pageRoute.iamCreateRole,
              path: 'iam-roles/:mode/:id?',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/CreateRole/CreateRole.vue'),
            },
            // {
            //   name: pageRoute.iamCreateRole,
            //   path: 'iam-create-role/:mode/:id',
            //   meta: {
            //     requiresAuth: true
            //   },
            //   component: () => import(/* webpackChunkName: "iam-dashboard" */'@/components/pages/InformationPortal/IAM/CreateRole/CreateRole.vue'),
            // },
          ]
        }
      ]
    },
    {
      path: '/publisher-api',
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      // component: requite('@/components/pages/InformationPortal/Publisher/Publisher.vue').default
      children: [
        {
          path: `/`,
          name: pageRoute.publisherAPI,
          meta: {
            requiresAuth: true,
          },
          component: require('@/components/pages/InformationPortal/Publisher/publisher.vue').default
        }
      ]
    },
    {
      path: '/short-url',
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      children: [
        {
          path: `/`,
          meta: {
            requiresAuth: true
          },
          component: require('@/components/pages/InformationPortal/ShortURLService/ShortURLHome/ShortURLHome.vue').default,
          children: [
            {
              path: `/`,
              name: pageRoute.shortURLSettings,
              meta: {
                requiresAuth: true
              },
              component: require('@/components/pages/InformationPortal/ShortURLService/ShortURLSettings/ShortURLSettings.vue').default,
              redirect: { name: pageRoute.shortURLSettingsRegisteredURL},
              children: [
                {
                  path: `/`,
                  name: pageRoute.shortURLSettingsRegisteredURL,
                  meta: {
                    requiresAuth: true
                  },
                  component: require('@/components/pages/InformationPortal/ShortURLService/ShortURLRegistered/ShortURLRegistered.vue').default,
                },
                {
                  name: pageRoute.shortURLActiveURLS,
                  path: `active-urls`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "short-url" */'@/components/pages/InformationPortal/ShortURLService/ShortURLActive/ShortURLActive.vue')
                },
                {
                  name: pageRoute.shortURLArchiveURLS,
                  path: `archive-urls`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "short-url" */'@/components/pages/InformationPortal/ShortURLService/ShortURLActive/ShortURLActive.vue')
                },
                {
                  name: pageRoute.shortURLDashboard,
                  path: `dashboard/:id`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "short-url" */'@/components/pages/InformationPortal/ShortURLService/UrlDashboard/UrlDashboard.vue')
                },
                {
                  name: pageRoute.shortURLInternalSettings,
                  path: `settings/:id`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "short-url" */'@/components/pages/InformationPortal/ShortURLService/UrlDashboard/UrlDashboard.vue')
                },
              ]
            }
          ]
        },
      ]
    },

    {
      path: '/locations',
      component: require('@/components/pages/LandingPage/LandingPage.vue').default,
      children: [
        {
          path: `/`,
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "locations" */'@/components/pages/InformationPortal/LocationService/LocationHome/LocationHome.vue'),
          children: [
            {
              path: `/`,
              name: pageRoute.locationSettings,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "locations" */'@/components/pages/InformationPortal/LocationService/LocationSettings/LocationSettings.vue'),
              children: [
                {
                  name: pageRoute.locationservice,
                  path: `/`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "locations" */'@/components/pages/InformationPortal/LocationService/Locations/Locations.vue')
                },
                // {
                //   path: `/`,
                //   name: pageRoute.shortURLSettingsRegisteredURL,
                //   meta: {
                //     requiresAuth: true
                //   },
                //   component: () => import(/* webpackChunkName: "short-url" */'@/components/pages/InformationPortal/ShortURLService/ShortURLRegistered/ShortURLRegistered.vue'),
                // },
                
              ]
            }
          ]
        },
      ]
    },
    
    {
      name: 'ip',
      path: pageRoute.ipHome,
      component: () => import('@/components/pages/LandingPage/LandingPage.vue'),
      children: [
        {
          name : pageRoute.overviewIp,
          path: pageRoute.overview,
          meta: {
            requiresAuth: true
          },
          component: require('@/components/pages/InformationPortal/Members/User.vue').default
        },
        {
          path: `${pageRoute.user}/:id`,
          meta: {
            requiresAuth: true
          },
          component: () => import('@/components/pages/InformationPortal/Members/Members.vue'),
          children: [
            {
              name: pageRoute.usersOverview,
              path: `/`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/Members/Overview/Overview.vue')
            },
            {
              name: 'user-collections',
              path: `collections`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Collections/Collection.vue')
            },
            {
              name: 'user-collections-page',
              path: `collections/:cid`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/Members/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: 'user-collection-about-page',
              path: `collections/:cid/about-page`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: 'user-dossiers',
              path: `dossiers`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Dossiers/Dossier.vue')
            },
            {
              name: 'user-dossiers-page',
              path: `dossiers/:did`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/Members/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: 'user-dossier-about-page',
              path: `dossiers/:did/about-page`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: 'user-about',
              path: `about`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | member'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Imprint/Imprint.vue')
            },
          ]
        },
        {
          path: `${pageRoute.authors}/:id`,
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/components/pages/InformationPortal/Authors/AuthorDetails.vue'),
          children: [
            {
              name: pageRoute.authorOverview,
              path: `/`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Overview/Overview.vue')
            },
            {
              name: pageRoute.authorArticles,
              path: `articles`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.authorCollections,
              path: `collections`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Collections/Collection.vue')
            },
            {
              name: pageRoute.authorCollectionPage,
              path: `collections/:cid`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.authorDossiers,
              path: `dossiers`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Dossiers/Dossier.vue')
            },
            {
              name: pageRoute.authorDossierPage,
              path: `dossiers/:did`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.authorCollectionAboutPage,
              path: `collections/:cid/about-page`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: pageRoute.authorDossierAboutPage,
              path: `dossiers/:did/about-page`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: pageRoute.authorAbout,
              path: `about`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Imprint/Imprint.vue')
            },
            {
              path: `settings`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Settings/Settings.vue'),
              children: [
                {
                  name: pageRoute.authorSettings,
                  path: `/`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import('@/components/pages/InformationPortal/ProfilePage/Settings/Profile/Profile.vue')
                },
                {
                  name: 'author-locations',
                  path: `locations`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import('@/components/pages/InformationPortal/Organisation/Locations/Locations.vue')
                },
              ]
            }
          ]
        },
        {
          path: `${pageRoute.publications}/:id`,
          meta: {
            requiresAuth: true
          },
          component: () => import('@/components/pages/InformationPortal/Publications/PublicationDetails.vue'),
          children: [
            {
              name: pageRoute.publicationOverview,
              path: `/`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Overview/Overview.vue')
            },
            {
              name: pageRoute.publicationArticles,
              path: `articles`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.publicationCollectionAboutPage,
              path: `collections/:cid/about-page`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: pageRoute.publicationDossierAboutPage,
              path: `dossiers/:did/about-page`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },

            {
              name: pageRoute.publicationCollections,
              path: `collections`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Collections/Collection.vue')
            },
            {
              name: pageRoute.publicationCollectionPage,
              path: `collections/:cid`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.publicationDossiers,
              path: `dossiers`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Dossiers/Dossier.vue')
            },
            {
              name: pageRoute.publicationDossierPage,
              path: `dossiers/:did`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.publicationAbout,
              path: `about`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Imprint/Imprint.vue')
            },
            {
              path: `settings`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Settings/Settings.vue'),
              children: [
                {
                  name: pageRoute.publicationSettings,
                  path: `/`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import('@/components/pages/InformationPortal/ProfilePage/Settings/Profile/Profile.vue')
                },
                {
                  name: 'publication-locations',
                  path: `locations`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import('@/components/pages/InformationPortal/Organisation/Locations/Locations.vue')
                },
              ]
            }
          ]
        },
        {
          path: `${pageRoute.publishers}/:id`,
          meta: {
            requiresAuth: true
          },
          component: () => import('@/components/pages/InformationPortal/Publishers/PublisherDetails.vue'),
          children: [
            {
              name: pageRoute.publisherOverview,
              path: `/`,
              meta: {
                requiresAuth: true,
                title: 'Newsroom'
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Overview/Overview.vue')
            },
            {
              name: pageRoute.publisherArticles,
              path: `articles`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.publisherCollections,
              path: `collections`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Collections/Collection.vue')
            },
            {
              name: pageRoute.publisherCollectionAboutPage,
              path: `collections/:cid/about-page`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: pageRoute.publisherDossierAboutPage,
              path: `dossiers/:did/about-page`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/CollectionAbout/About.vue')
            },
            {
              name: pageRoute.publisherCollectionPage,
              path: `collections/:cid`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.publisherDossiers,
              path: `dossiers`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Dossiers/Dossier.vue')
            },
            {
              name: pageRoute.publisherDossierPage,
              path: `dossiers/:did`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/ArticlesPage/ArticlesPage.vue')
            },
            {
              name: pageRoute.publisherAbout,
              path: `about`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Imprint/Imprint.vue')
            },
            {
              path: `settings`,
              meta: {
                requiresAuth: true
              },
              component: () => import('@/components/pages/InformationPortal/ProfilePage/Settings/Settings.vue'),
              children: [
                {
                  name: pageRoute.publisherSettings,
                  path: `/`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import('@/components/pages/InformationPortal/ProfilePage/Settings/Profile/Profile.vue')
                },
                {
                  name: 'publisher-locations',
                  path: `locations`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import('@/components/pages/InformationPortal/Organisation/Locations/Locations.vue')
                },
              ]
            }
          ]
        },
        {
          path: `${pageRoute.organisations}/:id`,
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/Organisation.vue'),
          children: [
            {
              path: `settings`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgSettings/OrgSettings.vue'),
              children: [
                {
                  name: pageRoute.organisationSettings,
                  path: `/`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/Profile/Profile.vue') 
                },
                {
                  name: pageRoute.organisationBilling,
                  path: `billing`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/Billing/Billing.vue') 
                },
                {
                  name: pageRoute.organisationMemberPrevileges,
                  path: `members`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/MemberPrivileges/MemberPrivileges.vue') 
                },
                {
                  name: pageRoute.organisationCollaborators,
                  path: `collaborators`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgCollaborators/OrgCollaborators.vue') 
                },
                {
                  name: 'verified-domains',
                  path: `domains`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/VerifiedDomains/VerifiedDomains.vue') 
                },
                {
                  name: pageRoute.organisationPublications,
                  path: `publications`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgPublications/OrgPublications.vue') 
                }
              ]
            },
            {
              path: `teams`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/Teams.vue'),
              children: [
                {
                  name: pageRoute.organisationTeams,
                  path: `/`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/OrgTeams.vue')
                },
                {
                  name: pageRoute.orgAddTeams,
                  path: pageRoute.orgAddTeams,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/TeamForm/TeamForm.vue')
                },
              ]
            },
            {
              path: `team/:tid`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/Teams.vue'),
              children: [
                {
                  name: pageRoute.editTeam,
                  path: `${pageRoute.editTeam}`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/TeamForm/TeamForm.vue')
                },
                {
                  name: pageRoute.teamMembers,
                  path: `${pageRoute.members}`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/TeamMembers/TeamMembers.vue')
                },
                {
                  name: pageRoute.teamOverview,
                  path: `overview`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/NoRecords.vue')
                },
                {
                  name: pageRoute.teamCollections,
                  path: `collection`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */ '@/components/pages/InformationPortal/Organisation/OrgTeams/TeamsCollection/TeamsCollection.vue'),
                },
                {
                  name: pageRoute.teamCollectionPage,
                  path: `collection/:cid`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */ '@/components/pages/InformationPortal/Organisation/OrgTeams/TeamsArticlePage/TeamsArticlePage.vue')
                },
                {
                  name: pageRoute.teamDossierPage,
                  path: `dossier/:cid`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */ '@/components/pages/InformationPortal/Organisation/OrgTeams/TeamsArticlePage/TeamsArticlePage.vue')
                },
                {
                  name: pageRoute.teamDossiers,
                  path: `dossier`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/TeamsCollection/TeamsCollection.vue')
                },
                {
                  name: pageRoute.teamSettings,
                  path: `settings`,
                  meta: {
                    requiresAuth: true
                  },
                  component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgTeams/TeamSettings/TeamSettings.vue')
                },
              ]
            },
            {
              name: pageRoute.organisationPeople,
              path: `people`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgPeople/OrgPeople.vue'),
            },
            {
              name: pageRoute.organisationArticles,
              path: `articles`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/NoRecords.vue'),
            },
            {
              name: pageRoute.organisationAbout,
              path: `about`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/ProfilePage/Imprint/Imprint.vue'),
            },
            {
              name: pageRoute.organisationOverview,
              path: `overview`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgOverview/OrgOverview.vue'),
            },
            {
              name: pageRoute.organisationCollections,
              path: `collection`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgCollection/OrgCollection.vue'),
            },
            {
              name: pageRoute.organisationDossiers,
              path: `dossier`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgCollection/OrgCollection.vue'),
            },
            {
              name: pageRoute.organisationCollectionPage,
              path: `collection/:cid`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */ '@/components/pages/InformationPortal/Organisation/OrgArticlePage/OrgArticlePage.vue')
            },
            {
              name: pageRoute.organisationDossierPage,
              path: `dossier/:cid`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgArticlePage/OrgArticlePage.vue')
            },
            {
              name: pageRoute.orgAddPublication,
              path: `add-publication`,
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "org" */'@/components/pages/InformationPortal/Organisation/OrgAddPublication/OrgAddPublication.vue')
            }
          ]
        },
        {
          path: pageRoute.card,
          meta: {
            requiresAuth: true,
            title: 'Newsroom | settings'
          },
          component: () => import('@/components/pages/Card/Card.vue'),
          children: [
            {
              path: '/',
              name: pageRoute.card,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | Listing'
              },
              component: () => import('@/components/pages/Card/MetaListing/MetaListing.vue')
            }, 
            {
              path: 'organisations',
              name: pageRoute.organisationCard,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | Organisation'
              },
              component: () => import('@/components/pages/Card/Organisation/Organisation.vue'),
            },
            {
              path: pageRoute.addOrganisation,
              name: pageRoute.addOrganisation,
              meta: {
                requiresAuth: true,
                title: 'Newsroom | Organisation'
              },
              component: () => import('@/components/pages/InformationPortal/Organisation/AddOrganisation/AddOrganisation.vue')
            },
          ]
        },
        {
          path: pageRoute.addAuthor,
          name: 'AddAuthor',
          meta: {
            requiresAuth: true,
            title: 'Newsroom'
          },
          component: () => import('@/components/pages/Card/Author/AddAuthor/AddAuthor.vue')
        },
        {
          path: pageRoute.editAuthor,
          name: 'EditAuthor',
          meta: {
            requiresAuth: true,
            title: 'Newsroom'
          },
          component: () => import('@/components/pages/Card/Author/EditAuthor/EditAuthor.vue')
        },
        {
          path: pageRoute.addPublisher,
          name: 'AddPublisher',
          meta: {
            requiresAuth: true,
            title: 'Newsroom'
          },
          component: () => import('@/components/pages/Card/Publisher/AddPublisher/AddPublisher.vue')
        },
        {
          path: pageRoute.editPublisher,
          name: 'EditPublisher',
          meta: {
            requiresAuth: true,
            title: 'Newsroom'
          },
          component: () => import('@/components/pages/Card/Publisher/EditPublisher/EditPublisher.vue')
        },
        {
          path: pageRoute.addPublication,
          name: 'AddPublication',
          meta: {
            requiresAuth: true,
            title: 'Newsroom'
          },
          component: () => import('@/components/pages/Card/Publication/AddPublication/AddPublication.vue')
        },
        {
          path: pageRoute.editPublication,
          name: 'EditPublication',
          meta: {
            requiresAuth: true,
            title: 'Newsroom'
          },
          component: () => import('@/components/pages/Card/Publication/EditPublication/EditPublication.vue')
        },
        {
          path: '',
          redirect: {
            name: pageRoute.overviewIp
          }
        }
      ]
    },
    {
      path: '' || '*',
      redirect: {
        name: pageRoute.overview
      }
    }
]

export default routes 
